import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { BookingDetailsAdditionalService } from '../../../../../store/slices/bookingCreationSlice';
import BookingDetailsServiceItem from '../../../CreateBooking/components/AdditionalServices/BookingDetailsServiceItem';

/**
 * Booked add-ons that don't exist at the venue/apartment the admin switched
 * to during edit — shown unchecked below the services list so they don't
 * silently vanish from the booking.
 */
const UnavailableServicesNotice = ({ services }: { services: BookingDetailsAdditionalService[] }) => {
    const { t } = useTranslation();
    if (services.length === 0) {
        return null;
    }
    return (
        <Box className={'mt-3'}>
            <Typography color={'text.secondary'} className={'text-sm mb-1'}>
                {t('create_booking.additional_services.unavailable_after_change')}
            </Typography>
            <Grid container spacing={1}>
                {services.map((service) => (
                    <Grid item xs={12} sm={6} key={service.serviceName}>
                        <BookingDetailsServiceItem
                            isQuantitySelectable={false}
                            service={service}
                            isChecked={false}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default UnavailableServicesNotice;
